import { useCallback, useEffect, useMemo } from "react";

import { fetchAllInspectorOptions } from "../../../../../redux/actions/user/users/users";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";

import { IComboBoxOption, SelectableOptionMenuItemType } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { useTheme } from "react-jss";
import { mapUserAdminDataToDropdownOption } from "../../../../../utils";
import { IBaseMultipleStringSelectorProps } from "../../../../request/common/selectors/IBaseMultipleSelectorProps";
import { MultipleStringSelectorFilter } from "../../../../request/common/selectors/multipleSelectorFilter/MultipleStringSelectorFilter";
import { AllInspectorSelectorStyle } from "./allInspectorSelectorStyle.jss";

export const AllInspectorSelector: React.FC<IBaseMultipleStringSelectorProps> = ({
    selectedKeys,
    onChange,
    title,
    propertyName,
    isDisabled,
    organismId: selectorOrganismId,
}) => {
    const { t } = useTranslation("common");
    const theme = useTheme();

    const style = AllInspectorSelectorStyle({ theme });

    const { organismId } = useAppSelector((state) => state.userData.profile);
    const { options, loading } = useAppSelector((store) => store.usersByRole.inspector);

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(fetchAllInspectorOptions(selectorOrganismId ?? organismId));
    }, [dispatch, organismId, selectorOrganismId]);

    const selectorFilterOptions = useMemo(() => options, [options]);

    return (
        <MultipleStringSelectorFilter
            selectedKeys={selectedKeys}
            onChange={onChange}
            options={selectorFilterOptions}
            label={title}
            propertyName={propertyName}
            isDisabled={isDisabled || loading}
        />
    );
};
